import {
  Dialog as MuiDialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogActions as MuiDialogActions,
  Typography as MuiTypography,
  styled,
  withStyles,
} from '@material-ui/core';

export const Dialog = styled(MuiDialog)({
  '& .MuiPaper-root': {
    padding: '0 22px',
    borderRadius: '6px',
    maxWidth: '449px',
  },
});

export const DialogTitle = styled(MuiDialogTitle)({
  padding: '16px 0',
  fontSize: '14px',

  '& .MuiTypography-h6': {
    fontWeight: 'bold',
  },
});

export const DialogContent = styled(MuiDialogContent)({
  padding: '0 0 8px',
  display: 'flex',
  flexDirection: 'column',
});

export const DialogActions = styled(MuiDialogActions)({
  display: 'flex',
  paddingBottom: '30px',
});

export const Typography = withStyles({
  root: {
    fontWeight: 400,
    fontSize: '14px',
    whiteSpace: 'break-spaces',
    marginBottom: '10px',
  },
})(MuiTypography);
